import React from "react";
import "./ForgetPassword.scss";
import Image from "../../components/image/Image";
import { AppIcons } from "../../data/appIcons";
import ForgetPasswordForm from "../../features/forgetPassword/ForgetPassword";

const ForgetPasswordPage = () => {
  return (
    <div>
      <div className="main-login-section">
        <div className="min-h-full flex items-center justify-center w-full login-wrapper">
          <div className="login-main-bg">
            <div className="reset-logo-container">
              <Image
                imagePath={AppIcons.logoImage}
                imgCustomClassName="open-bar"
                altText="Icon"
              />
            </div>
            <div className="reset-title-container">
              <h2 className="reset-title text-center  text-gray-900">Reset Password</h2>
            </div>
            <div>
              <ForgetPasswordForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPasswordPage;
